import {
    Box,
    FormControl,
    FormLabel,
    List,
    ListItem,
    Stack,
    Text,
} from '@chakra-ui/react';

import {
    descriptionStyling,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';
import { AutoResizeTextArea } from 'components/v4/Textarea';

const Comments = ({
    hasDescription = false,
    darkMode,
    state,
    onChange,
    walkthroughId,
}) => {
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            data-walkthroughid={walkthroughId}>
            <Stack
                direction="row"
                sx={{ ...stackStyling(hasDescription), height: 'auto' }}>
                <Box width={190}>
                    <FormLabel
                        sx={{
                            ...formLabelStyling(darkMode),
                            paddingTop: '16px',
                        }}>
                        Comments
                    </FormLabel>
                    {hasDescription && (
                        <Text
                            sx={{
                                ...descriptionStyling,
                                color: darkMode ? 'gray.200' : '#757575',
                                pb: 4,
                            }}
                            maxWidth={250}>
                            Please use the comment section to add further
                            details if applicable:
                            <List>
                                <ListItem>
                                    Please indicate the preferred Area/City code
                                </ListItem>
                                <ListItem>
                                    Exact Suburb/Town if the requested phone
                                    number pertains to a location different from
                                    the one mentioned in the company&apos;s
                                    address
                                </ListItem>
                            </List>
                        </Text>
                    )}
                </Box>
                <AutoResizeTextArea
                    minRows={hasDescription ? 3 : 2}
                    className="!my-[16px] !me-[54px]"
                    value={state?.comments}
                    borderColor={darkMode ? 'dark.tcap-borderGray' : 'inherit'}
                    bg={darkMode ? 'dark.bgDark' : '#FFF'}
                    onChange={onChange}
                />
            </Stack>
        </FormControl>
    );
};

export default Comments;
